import { useEffect, useState, useSyncExternalStore } from 'react';
import { estadoDeSesion, milisegundosRestantes, suscribirse } from './almacen';
import type { EstadoDeSesion, Sesion } from './almacen';

/**
 * Los hooks con los que las pantallas leen la sesión.
 *
 * Se usa `useSyncExternalStore` y no un contexto con `useState` porque la
 * sesión **se cierra desde afuera de React**: la cierra la respuesta `401` de
 * un pedido HTTP, que puede pasar mientras no hay ningún evento de React a la
 * vista. Este hook es la forma que React da para suscribirse a un almacén
 * externo sin perder actualizaciones.
 */
export function useSesion(): EstadoDeSesion {
  return useSyncExternalStore(suscribirse, estadoDeSesion, estadoDeSesion);
}

/** Minutos enteros que le quedan al token, o `null` si no hay sesión. */
export function useMinutosParaVencer(sesion: Sesion | null): number | null {
  const [minutos, setMinutos] = useState(() => calcular(sesion));

  useEffect(() => {
    setMinutos(calcular(sesion));
    if (!sesion) {
      return undefined;
    }
    // Medio minuto: suficiente para que un aviso de "quedan 5 minutos" no
    // aparezca tarde, y lo bastante espaciado como para no despertar la pestaña
    // por gusto.
    const reloj = setInterval(() => setMinutos(calcular(sesion)), 30_000);
    return () => clearInterval(reloj);
  }, [sesion]);

  return minutos;
}

function calcular(sesion: Sesion | null): number | null {
  if (!sesion) {
    return null;
  }
  return Math.floor(milisegundosRestantes(sesion) / 60_000);
}
